module.exports = __webpack_public_path__ + "img/txt_series_115.f7d6c687.png";